import React, { useState } from "react";
import { Box, Alert, Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OverviewTab from "./Tabs/OverviewTab";
import CredentialsTab from "./Tabs/CredentialsTab";
import SimulatorTab from "./Tabs/SimulatorTab";
import CliqueTab from "./Tabs/CliqueTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const PrepbusinessPage = () => {
  // Generall
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Clear any existing messages when switching tabs
    setError(null);
    setSuccess(null);
  };

  return (
    <DashboardLayout>
      <MDBox>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Prepbusiness
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Overview" />
            <Tab label="Credentials" />
            <Tab label="Cliques / Rules" />
            <Tab label="Simulator" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <CredentialsTab />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <CliqueTab />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <SimulatorTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default PrepbusinessPage;
